import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "colname"
})
export class ColNamePipe implements PipeTransform {
  constructor() { }
  transform(val: string, key: string, traget: string): any {
    return val ? val.split(key).map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(traget) : val;
  }
}
